import { Component } from "react"

/* Components */
import { Layout, OperatorFilter, DateFilter } from "../../components"

/* Helpers */
import { utils, datetime } from "../../helpers"

/* Redux */
import { connect } from "react-redux"

/* REST API */
import { all } from "../../api/Dashboard"

/* Moment */
import moment from "moment"
import "moment/locale/ru"

/* Export Excel */
import { downloadExcel as downloadXlsx } from "react-export-table-to-excel-xlsx"

/* Router */
import { Link } from "react-router-dom"

/* Constants */
import { env } from "../../constants"

/* Translate */
import { t } from "../../translates/translate"


const GAME_TYPES = [
    { key: "multi", text: "Live" },
    { key: "vip", text: "VIP" },
    { key: "roulette", text: "Roulette" },
    { key: "electron", text: "Electron" },
]


/* Page Dashboard */
class Dashboard extends Component {

    constructor() {
        super()

        const date = utils.getToday()

        this.state = {
            status: "loading",
            data: null,

            operators: [],

            filter: false,
            selected: "today",
            active: "today",
            start: date.startDate,
            end: date.endDate,
            type: "multi",

            games: [],
            waiting: false,

            cnt: 0,
        }
    }

    componentDidMount = () => {
        this.load(false, true)
    }

    /* Get DATES */
    _getDATES = () => [
        { key: "all", text: t("dashboard.filterAll") },
        { key: "today", text: t("dashboard.filterToday") },
        { key: "week", text: t("dashboard.filterWeek") },
        { key: "month", text: t("dashboard.filterMonth") },
        { key: "year", text: t("dashboard.filterYear") },
        { key: "period", text: t("dashboard.filterPeriod") },
    ]

    /* Load action */
    load = (reload = false, initial = false) => {

        const { active, start, end, operators, cnt } = this.state

        let list = operators

        if (initial) {
            list = this.props.operators
            this.setState({ operators: list })
        }

        if (!list || !Array.isArray(list) || list.length < 1) {
            setTimeout(() => {
                this.setState({ operators: this.props.operators, cnt: cnt + 1 },
                    () => cnt < 5 ? this.load(false, initial)
                        : this.setState({ status: "permission", data: null, cnt: 0 })
                )
            }, 700)
            return
        }

        if (reload) {
            this.setState({ status: "loading", cnt: 0 })
        }

        all({ ids: utils.arrayID(list), filter: active, start, end }).then((response) => {
            if (response.status === 200) {
                this.setState({ status: "ok", data: response.data, games: response.data.games, cnt: 0 })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission", data: null, cnt: 0 })
            }
            else if (response.status === 498) {
                this.setState({ status: "key", data: null, cnt: 0 })
            }
            else {
                this.setState({ status: "error", data: null, cnt: 0 })
            }
        }).catch(() => {
            this.setState({ status: "network", data: null, cnt: 0 })
        })

    }

    /* Apply action */
    apply = () => {

        /* Fields */
        const { selected } = this.state

        /* All */
        if (selected === "all") {
            this.setState({ active: selected, filter: false }, () => this.load(true))
        }
        /* Period */
        else if (selected === "period") {
            const { start, end } = this.state
            const formattedStart = moment(start).format("YYYY-MM-DD 00:00:00")
            const formattedEnd = moment(end).format("YYYY-MM-DD 23:59:59")
            this.setState({ active: selected, start: formattedStart, end: formattedEnd, filter: false }, () => this.load(true))
        }
        else {
            const { start, end } = datetime.getDashboardFilterDates(selected)
            this.setState({ active: selected, start, end, filter: false }, () => this.load(true))
        }

    }

    /* Get Filter Date */
    getFilterDate = () => {

        const { active, start, end } = this.state

        const DATES = this._getDATES()
        const index = DATES.findIndex((e) => e.key === active)

        if (index > -1) {

            let text = `${moment(start).format("DD MMM YYYY")} - ${moment(end).format("DD MMM YYYY")}`

            if (active === "all") {
                text = ""
            }

            return { filter: DATES[index].text, text }
        }

        return { filter: DATES[0].text, text: "" }
    }

    /* Download Excel */
    downloadExcel = () => {

        /* FIELDS */
        const { games, data } = this.state

        /* CHECK DATA */
        if (data && games && Array.isArray(games) && games.length > 0) {

            /* TABLE FIELDS */
            const filtered = this.getFilterDate()
            const title = `${t("dashboard.gamesReport")} ${String(filtered.filter).toUpperCase()} (${filtered.text})`

            /* Prepare Header */
            const header = {
                name: t("dashboard.reportGameName"),
                players: t("dashboard.reportPlayers"),
                rounds: t("dashboard.reportRounds"),
                debit: t("dashboard.reportDebit"),
                credit: t("dashboard.reportCredit"),
                total: "TOTAL (GGR)",
            }
            const body = [{ name: title }, { name: "" }, header]

            /* Prepare Body */
            games.forEach((game) => {
                body.push({
                    name: utils.checkValue(game.name, "-"),
                    players: utils.checkValue(game.players, "0"),
                    rounds: utils.checkValue(game.rounds, "0"),
                    debit: utils.convertor(parseFloat(Math.abs(game.debit)), "$", 0, " "),
                    credit: utils.convertor(parseFloat(Math.abs(game.credit)), "$", 0, " "),
                    total: `${game.total >= 0 ? "+" : "-"} ${utils.convertor(parseFloat(Math.abs(game.total)), "$", 0, " ")}`,
                })
            })

            /* Space */
            body.push({ name: "" })

            /* Prepare Total */
            body.push({
                name: t("dashboard.reportTotal"),
                players: utils.checkValue(data.players, "0"),
                rounds: utils.checkValue(data.rounds, "0"),
                debit: utils.convertor(parseFloat(Math.abs(data.debit)), "$", 0, " "),
                credit: utils.convertor(parseFloat(Math.abs(data.credit)), "$", 0, " "),
                total: `${data.total >= 0 ? "+" : "-"} ${utils.convertor(parseFloat(Math.abs(data.total)), "$", 0, " ")}`,
            })

            /* Call Download Excel */
            downloadXlsx({
                fileName: `${t("dashboard.gamesReport")} ${String(filtered.filter).toUpperCase()}`,
                sheet: t("dashboard.reportSheet"),
                tablePayload: { header: [], body },
            })
        }

    }

    /* Set a period value */
    setDate = (data, key) => {
        if (key === "start") {
            this.setState({ start: data })
        }
        else {
            this.setState({ end: data })
        }
    }

    /* Draw Header */
    _header = () => {

        const { operators } = this.state

        const json = localStorage.getItem("user")
        const user = json ? JSON.parse(json) : null
        const date = this.getFilterDate()

        return (
            <div className="dashboard-header">

                <div className="dashboard-header-user">
                    <div className="dashboard-header-text">{t("dashboard.hello")}</div>
                    {user !== null && user !== undefined && <div className="dashboard-header-title">{user.name}</div>}
                </div>

                <div className="dashboard-header-filter">
                    <div onClick={() => this.setState({ filter: true })} className="dashboard-filter">
                        <img src="/dashboard/calendar.png" alt="Calendar" />
                        <div className="dashboard-filter-text">
                            <div className="dashboard-filter-text-type">{date.filter}</div>
                            <div className="dashboard-filter-text-value">{date.text}</div>
                        </div>
                    </div>
                    <div onClick={() => this.downloadExcel()} className="dashboard-xls-button">.XLSX</div>
                </div>

                {operators && operators.length > 0 ? <OperatorFilter operators={operators} setOperators={(list) => this.setState({ operators: list })} apply={() => this.load(true)} /> : null}

            </div>
        )
    }

    /* Draw Filter Modal */
    _filter = () => {

        /* Fields */
        const { filter, start, end, selected, active } = this.state

        return (
            <DateFilter
                filter={filter}
                start={start}
                end={end}
                selected={selected}
                setSelected={(key) => this.setState({ selected: key })}
                active={active}
                close={() => this.setState({ filter: false, selected: active })}
                apply={() => this.apply()}
                setDate={(date, type) => this.setDate(date, type)}
                DATES={this._getDATES()}
            />
        )
    }




    /* TOP WIDGET */
    _top = () => {

        /* Fields */
        const { data } = this.state

        let percentage = 0
        if (data.debit && parseFloat(data.debit) > 0) {
            percentage = Number(parseFloat(data.total) / parseFloat(data.debit) * 100).toFixed(0)
        }

        return (
            <div className="dashboard-top-widget">

                {/* BATTERY WIDGET */}
                <div className="dashboard-battery-widget">

                    <div className="dashboard-battery-widget-container">
                        <div className="dashboard-battery-widget-layout">
                            {percentage && Math.abs(percentage) > 0 &&
                                <div className={`dashboard-battery-widget-container-inner ${percentage > 0 ? "green" : "red"}`} style={{ width: `${Math.abs(percentage)}%` }}>
                                    <div className="dashboard-battery-widget-container-text">{percentage}%</div>
                                </div>
                            }
                        </div>
                    </div>

                    <div className="dashboard-battery-numbers">

                        <div className="dashboard-battery-widget-box">
                            <img src="/dashboard/increase.png" alt="Increase" />
                            <div className="dashboard-battery-widget-box-text">
                                <div className="dashboard-battery-widget-box-key">Debit <img src="/images/similar.png" alt="Calculate" /></div>
                                <div className="dashboard-battery-widget-box-value">+ {utils.convertor(parseFloat(Math.abs(data.debit)), "$", 0, " ")}</div>
                            </div>
                        </div>

                        <div className="dashboard-battery-widget-box">
                            <img src="/dashboard/decrease.png" alt="Decrease" />
                            <div className="dashboard-battery-widget-box-text">
                                <div className="dashboard-battery-widget-box-key">Credit <img src="/images/similar.png" alt="Calculate" /></div>
                                <div className="dashboard-battery-widget-box-value">- {utils.convertor(parseFloat(Math.abs(data.credit)), "$", 0, " ")}</div>
                            </div>
                        </div>

                        <div className="dashboard-battery-widget-box">
                            <img src="/dashboard/calculate.png" alt="Increase" />
                            <div className="dashboard-battery-widget-box-text">
                                <div className="dashboard-battery-widget-box-key">{t("dashboard.profit")} <img src="/images/similar.png" alt="Calculate" /></div>
                                <div className={`dashboard-battery-widget-box-value ${data.total >= 0 ? "green" : "red"}`}>
                                    {data.total >= 0 ? "+ " : "- "}
                                    {utils.convertor(parseFloat(Math.abs(data.total)), "$", 0, " ")}
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

                <div className="dashboard-top-numbers-widget">

                    {/* ANGLE WIDGET */}
                    <div className="dashboard-top-angle-widget">
                        <div className="dashboard-top-angle-widget-box">
                            <div className="dashboard-top-angle-widget-text">{t("dashboard.visitors")}</div>
                            <div className="dashboard-top-angle-widget-value">{utils.checkValue(data.visitor, "-")}</div>
                        </div>
                        <div className="dashboard-top-angle-widget-box">
                            <div className="dashboard-top-angle-widget-text">{t("dashboard.players")}</div>
                            <div className="dashboard-top-angle-widget-value">{utils.checkValue(data.players, "-")}</div>
                        </div>
                        <div className="dashboard-top-angle-widget-box">
                            <div className="dashboard-top-angle-widget-text">{t("dashboard.rounds")}</div>
                            <div className="dashboard-top-angle-widget-value">{utils.checkValue(data.rounds, "-")}</div>
                        </div>
                        <div className="dashboard-top-angle-widget-box">
                            <div className="dashboard-top-angle-widget-text">{t("dashboard.games")}</div>
                            <div className="dashboard-top-angle-widget-value">{utils.checkValue(data.tables, "-")}</div>
                        </div>
                    </div>

                    {/* INSTRUMENTS WIDGET */}
                    <div className="dashboard-top-instuments-widget">

                        <div className="dashboard-top-instument-note">
                            <img src="/images/game/writing.png" alt="Note" />
                            <div className="dashboard-top-instument-text">{t("dashboard.notes")}</div>
                        </div>

                        <div className="dashboard-top-instument-activity">
                            <img src="/images/activity.png" alt="Activity" />
                            <div className="dashboard-top-instument-text">{t("dashboard.activity")}</div>
                        </div>

                    </div>

                </div>

            </div>
        )
    }

    /* Draw Game */
    _game = (item, index) => {

        /* Determine type */
        const type = index === 0 ? "popular" : "game"

        /* Determine Percentage */
        let percentage = 0
        if (item.debit && parseFloat(item.debit) > 0) {
            percentage = Number(parseFloat(item.total) / parseFloat(item.debit) * 100).toFixed(0)
        }

        return (
            <Link to={`/table/${item.game}/${item.uid}`} className={`dashboard-${type}-widget`} key={`${item.uid}-${index}`} style={{ background: utils.checkValue(item.backColor, "#3f51b5") }}>

                {/* Draw Image */}
                {item.gameImg && <img src={`${env.mediapoint}images/table-images/${item.gameImg}`} alt="Game" />}

                <div className="dashboard-game-widget-head">

                    {/* Popular Tag */}
                    <div className="dashboard-game-widget-tags">
                        {index === 0 &&
                            <div className="dashboard-popular-widget-tag">
                                <img src="/dashboard/fire.png" alt="Fire" />
                                <div className="dashboard-popular-widget-tag-text">Popular</div>
                            </div>
                        }
                    </div>

                    {/* Players */}
                    <div className={`dashboard-${type}-widget-players`}>
                        <div className={`dashboard-${type}-widget-player-count`}>{item.players} {item.players > 4 ? t("dashboard.playersWord5") : (item.players === 1 || item.players === 0) ? t("dashboard.playersWord1") : t("dashboard.playersWord24")}</div>
                    </div>

                </div>

                {/* Title */}
                <div className={`dashboard-${type}-widget-title`}>{item.name}</div>

                {/* Numbers */}
                <div className={`dashboard-${type}-widget-numbers`}>

                    {/* Credit */}
                    <div className={`dashboard-${type}-widget-box`}>
                        <img src="/dashboard/increase.png" alt="Increase" />
                        <div className={`dashboard-${type}-widget-box-text`}>
                            <div className={`dashboard-${type}-widget-box-key`}>Debit</div>
                            <div className={`dashboard-${type}-widget-box-value`}>+ {utils.convertor(parseFloat(Math.abs(item.debit)), "$", 0, " ")}</div>
                        </div>
                    </div>

                    {/* Credit */}
                    <div className={`dashboard-${type}-widget-box`}>
                        <img src="/dashboard/decrease.png" alt="Decrease" />
                        <div className={`dashboard-${type}-widget-box-text`}>
                            <div className={`dashboard-${type}-widget-box-key`}>Credit</div>
                            <div className={`dashboard-${type}-widget-box-value`}>- {utils.convertor(parseFloat(Math.abs(item.credit)), "$", 0, " ")}</div>
                        </div>
                    </div>

                    {/* GGR */}
                    <div className={`dashboard-${type}-widget-box`}>
                        <img src="/dashboard/cards.png" alt="Cards" />
                        <div className={`dashboard-${type}-widget-box-text`}>
                            <div className={`dashboard-${type}-widget-box-key`}>GGR</div>
                            <div className={`dashboard-${type}-widget-box-value`}>
                                {item.total >= 0 ? "+ " : "- "}
                                {utils.convertor(parseFloat(Math.abs(item.total)), "$", 0, " ")}
                            </div>
                        </div>
                    </div>

                    {/* Rounds */}
                    <div className={`dashboard-${type}-widget-box`}>
                        <img src="/images/transaction.png" alt="Cards" />
                        <div className={`dashboard-${type}-widget-box-text`}>
                            <div className={`dashboard-${type}-widget-box-key`}>{t("dashboard.transactions")}</div>
                            <div className={`dashboard-${type}-widget-box-value`}>{utils.checkValue(item.transactions, "0")}</div>
                        </div>
                    </div>

                    {/* Rounds */}
                    <div className={`dashboard-${type}-widget-box`}>
                        <img src="/dashboard/cards.png" alt="Cards" />
                        <div className={`dashboard-${type}-widget-box-text`}>
                            <div className={`dashboard-${type}-widget-box-key`}>{t("dashboard.rounds")}</div>
                            <div className={`dashboard-${type}-widget-box-value`}>{utils.checkValue(item.rounds, "0")}</div>
                        </div>
                    </div>

                    {/* PROFIT */}
                    <div className={`dashboard-${type}-widget-box`}>
                        <img src="/dashboard/percent.png" alt="Percent" />
                        <div className={`dashboard-${type}-widget-box-text`}>
                            <div className={`dashboard-${type}-widget-box-key`}>PROFIT</div>
                            <div className={`dashboard-${type}-widget-box-value`}>{percentage} %</div>
                        </div>
                    </div>

                </div>

                <div className="dashboard-game-widget-shadow" />

            </Link>
        )
    }

    /* Draw Games */
    _games = () => {

        /* Fields */
        const { games, type } = this.state
        const list = games.filter((e) => e.type === type)

        return (
            <div className="dashboard-games-container">
                {list.map((item, index) => this._game(item, index))}
            </div>
        )
    }

    render = () => {

        /* Fields */
        const { type, status } = this.state

        /* Layout */
        if (status !== "ok") {
            return <Layout status={status} reload={() => this.load(true)} />
        }

        return (
            <div className="page">

                {/* HEADER */}
                {this._header()}

                <div className="dashboard-container">

                    {/* TOP WIDGETS */}
                    {this._top()}

                    {/* Games */}
                    <div className="dashboard-games">

                        {/* GAME HEADER */}
                        <div className="dashboard-games-header">
                            <h2>{t("dashboard.games")}</h2>
                            <div className="dashboard-games-header-types">
                                {GAME_TYPES.map((item, index) =>
                                    <div onClick={() => this.setState({ type: item.key })} className={`dashboard-games-header-type ${item.key === type ? "active" : "default"}`} key={`${index}`}>{item.text}</div>
                                )}
                            </div>
                        </div>

                        {/* GAMES */}
                        {this._games()}

                    </div>

                </div>

                {/* FILTER MODAL */}
                {this._filter()}

            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        operators: state.operators,
        language: state.language,
    }
}

export default connect(mapStateToProps)(Dashboard)